<template>
  <div class="panel-pokreni">
    <p class="title">
      <span class="month">{{ month }}</span> <i>|</i> {{ round.title }}<br>
      je krenulo:
    </p>
    <p class="time">
      {{ timeUntilRoundEnd.value }}
      <small>{{ timeUntilRoundEnd.description }}</small>
    </p>
    <a href="#" class="button-1 red" @click.prevent="startRound"><span>Pokreni kviz</span></a>
  </div>
</template>

<script>
import { RoundUtils } from '../utils/roundUtils.js'
import { TimeUtils } from '../utils/timeUtils'
export default {
    name: 'panel-pokreni',
    methods: {
        startRound () {
            const route = RoundUtils.startRound(this.round)
            if (route) {
                this.$router.push(route)
            }
        }
    },
    computed: {
        month () {
            return TimeUtils.getCurrentMonthLongName()
        },
        round () {
            return this.$store.getters.round
        },
        counters () {
            return this.$store.state.counters
        },
        timeUntilRoundEnd () {
            return {
                value: this.counters.minutes > 0 ? this.counters.minutes : this.counters.seconds,
                description: this.counters.minutes > 0 ? 'MIN' : 'SEK'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.panel-pokreni {
  position: relative;
  box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
  background-color: #001840;
  border-radius: 10px;
  padding: 26px 16px;
  color: #fff;
  font-family: "mPlus";

  .title {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: .2px;
    margin-bottom: 30px;
    span.month {
      text-transform: capitalize;
    }
    i {
      color: #85c0f8;
      margin-left: 5px;
    }
  }
  .time {
    font-size: 30px;
    letter-spacing: 1px;
    margin-bottom: 30px;

    small {
      display: block;
      font-family: "axiforma";
      font-size: 10px;
      color: #85c0f8;
      text-transform: uppercase;
    }
  }
  .button-1 {
    min-width: 210px;
  }
}
</style>
